<template>
  <v-row>
    <v-col cols="12">
      <v-text-field v-model="data.name" label="name"></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-text-field v-model="data.order" label="order"></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { Strings } from '../../../utils'
export default {
  name: 'KeywordForm',
  props: ['data'],
  data() {
    return {
      icons: ['mdi-rewind', '', 'mdi-fast-forward'],
      baseUrl: Strings.baseUrl,
      deleteFileLoading: false
    }
  },
  methods: {}
}
</script>

<style scoped></style>
